module.exports = __webpack_public_path__ + "static/media/plus-grey.62281ca8.svg";